import { useNavigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import MoveEmployeeModal from 'modules/timeoff/components/TimeoffPolicy/MoveEmployee'

const MoveEmployeeModalPage = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { id, employeeId } = useStrictParams<'id' | 'employeeId'>()

  const onClose = () => {
    navigate(navigation.settings.timeoffPolicies.id.employees.fullPath({ id }))
  }

  return (
    <MoveEmployeeModal
      timeoffPolicyId={Number(id)}
      employeeId={Number(employeeId)}
      onClose={onClose}
    />
  )
}

export default MoveEmployeeModalPage
